import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[loadQuestion]',
    standalone: false
})
export class LoadQuestionDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
